import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Loading.module.css';
export default function AccountLoading(_a) {
    var _b = _a.id, id = _b === void 0 ? 'load' : _b;
    return (_jsx("div", { className: styles.loadingContainer, "data-testid": id, children: _jsxs("div", { className: styles.loading, children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }) }));
}
